export const projectGallery = [
  { src: "/assets/facade-main.webp", alt: "Fachada do La Courbe Tower" },
  { src: "/assets/entrance-detail.webp", alt: "Acesso principal do La Courbe Tower" },
  { src: "/assets/balcony-wide.webp", alt: "Detalhe das curvas da fachada" },
  { src: "/assets/facade-day-two.webp", alt: "Vista frontal do La Courbe Tower" },
];

export const amenities = [
  ["Espaço Fitness", "/assets/fitness-wide.webp", "Um ambiente para manter o corpo em movimento sem sair de casa, integrando praticidade, bem-estar e rotina."],
  ["Espaço Market", "/assets/market-wide.webp", "Comodidade para resolver pequenas necessidades sem interromper o ritmo da vida."],
  ["Lavanderia", "/assets/laundry-wide.webp", "Funcionalidade que simplifica a rotina e otimiza tempo, espaço e praticidade."],
  ["Espaço Pet", "/assets/pet-wide.webp", "Cuidado, convivência e praticidade para tornar a rotina dos moradores e seus pets mais confortável."],
  ["Coworking", "/assets/coworking-wide.webp", "Um ambiente reservado, funcional e inspirador para trabalhar, estudar e produzir."],
  ["Piscina", "/assets/pool-wide.webp", "No ponto mais alto do empreendimento, um convite para relaxar, contemplar e transformar o cotidiano em experiência."],
  ["Espaço Gourmet", "/assets/gourmet-wide.webp", "Conforto, elegância e convivência para encontros, celebrações e boas conversas."],
  ["Espaço Parrilla", "/assets/parrilla-wide.webp", "Uma experiência intimista e acolhedora para encontros especiais e sabores marcantes."],
  ["Terraço Lúdico", "/assets/terrace-wide.webp", "Um espaço para desacelerar, respirar e observar a cidade por outro ângulo."],
  ["Estacionamento", "/assets/parking-wide.webp", "Segurança, organização e infraestrutura para carros elétricos integradas à rotina."],
  ["Bicicletário", "/assets/bike-wide.webp", "Estrutura para deslocamentos mais práticos, sustentáveis e conectados ao ritmo urbano."],
].map(([title, image, description]) => ({ title, image, description }));

export const apartments = {
  studio: {
    label: "Studio",
    title: "Integração para viver com liberdade.",
    description: "Ambientes funcionais, conectados e desenhados para aproveitar cada centímetro.",
    measure: "21,76 a 29,87 m²",
    image: "/assets/studio-living.webp",
    alt: "Interior de um studio no La Courbe Tower",
    features: ["Sacada com churrasqueira", "Fechadura eletrônica", "Infraestrutura para ar-condicionado"],
  },
  garden: {
    label: "Studio Garden",
    title: "Mais espaço para viver do seu jeito.",
    description: "Unidades com área externa privativa para ampliar possibilidades e aproximar a rotina do ar livre.",
    measure: "19 a 22,39 m² + garden",
    image: "/assets/studio-wide.webp",
    alt: "Studio Garden do La Courbe Tower",
    features: ["Gardens de 5,10 a 31,58 m²", "Sacada com churrasqueira", "Acesso inteligente"],
  },
  onebed: {
    label: "1 dormitório",
    title: "Privacidade e conforto em equilíbrio.",
    description: "Uma configuração versátil para quem procura ambientes bem definidos sem abrir mão da fluidez.",
    measure: "Até 51,07 m²",
    image: "/assets/onebed-wide.webp",
    alt: "Apartamento de um dormitório no La Courbe Tower",
    features: ["Opções com sacada", "Sacada com churrasqueira", "Infraestrutura para ar-condicionado"],
  },
};
